import { shouldPersistRouteState } from '@src/constants/navigation';
import { onTabClose } from '@src/modules/app/appHelpers';
import {
  storeRirekishoPathToLocalStorage,
  storeRouterStateToLocalStorage,
} from '@src/modules/local_storage_utils';
import { useEffect } from 'react';

const RIREKISHO_ROUTE_PREFIX = '/rirekisho/';

/**
 * ルート遷移時の保存やタブクローズ警告をまとめて管理するフック。
 */
export const useRoutePersistence = (path: string, enableCloseWarning: boolean): void => {
  useEffect(() => {
    if (!enableCloseWarning) {
      return;
    }
    return onTabClose(true);
  }, [enableCloseWarning]);

  useEffect(() => {
    if (!shouldPersistRouteState(path)) {
      return;
    }

    if (path.startsWith(RIREKISHO_ROUTE_PREFIX)) {
      storeRirekishoPathToLocalStorage(path);
      return;
    }

    storeRouterStateToLocalStorage(path);
  }, [path]);
};
